import React from 'react';
import { Row, Col } from 'antd';
import { TeamMemberSectionProps } from './TeamMemberSection.types';
import { SectionContainer, SectionTitle, titleStyle } from './TeamMemberSection.styles';
import TeamMemberCard from '../TeamMemberCard/TeamMemberCard';
import { useI18n } from '../../hooks/useI18n';

const TeamMemberSection: React.FC<TeamMemberSectionProps> = React.memo(({ titleKey, members }) => {
  const { t, language } = useI18n();

  return (
    <SectionContainer>
      <SectionTitle level={2} style={titleStyle}>
        {t(titleKey)}
      </SectionTitle>
      <Row gutter={[72, 24]} justify="center" align="top">
        {members.map((member, index) => (
          <Col key={`${member.name}-${index}`} xs={24} sm={12} md={12} lg={8}>
            <TeamMemberCard
              picture={member.picture}
              name={member.name}
              role={language === 'es' ? member.roleEs : member.roleEn}
              socialMedia={member.socialMedias}
            />
          </Col>
        ))}
      </Row>
    </SectionContainer>
  );
});

TeamMemberSection.displayName = 'TeamMemberSection';

export default TeamMemberSection;
